module.exports = __webpack_public_path__ + "static/media/tyha.d6c25ad9.png";